import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Info } from 'lucide-react';

// GOVERNANCE (Phase 1 closeout): this legacy screen previously created/edited/deleted
// records in the legacy `locations` collection — which is NOT the ROUT location master
// (`service_locations`) and must never be mutated. All mutating affordances have been
// removed. The route/component is retained (deprecated notice) so existing links don't
// break. The authoritative surface is Administration › Service Locations.
const LocationManagement = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Location Management (Deprecated)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4" data-testid="legacy-locations-deprecated">
            <Info className="h-5 w-5 shrink-0 text-amber-600" />
            <div className="text-sm text-slate-700">
              <p className="font-semibold text-slate-800">This screen has been retired.</p>
              <p className="mt-1">
                Service-location master records are now managed in the authoritative
                <span className="font-semibold"> Company Master Data › Service Locations </span>
                area (TFS Administration Hub and ROUT Administration). Master records are
                retained permanently and can be deactivated — never permanently deleted —
                to preserve all identifiers, relationships and history.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LocationManagement;
